import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "channel-grid"
};
const _hoisted_2 = {
  class: "desc"
};
const _hoisted_3 = {
  key: 0,
  class: "qr-code-wrapper"
};
const _hoisted_4 = ["onMouseenter", "onMouseleave"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  class: "qr-tip"
};
const _hoisted_8 = {
  class: "qr-account"
};
const _hoisted_9 = {
  key: 1,
  class: "copy-wrapper"
};
const _hoisted_10 = ["onMouseenter", "onMouseleave"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 0,
  class: "info-popup"
};
const _hoisted_13 = {
  class: "info-text"
};
const _hoisted_14 = {
  class: "faq"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 0,
  class: "faq-content"
};
const _hoisted_17 = {
  class: "cooperation"
};
const _hoisted_18 = {
  class: "form-row"
};
const _hoisted_19 = {
  class: "form-group"
};
const _hoisted_20 = {
  class: "form-group"
};
const _hoisted_21 = {
  class: "form-row"
};
const _hoisted_22 = {
  class: "form-group"
};
const _hoisted_23 = {
  class: "form-group"
};
const _hoisted_24 = {
  class: "form-group full-width"
};
const _hoisted_25 = {
  key: 0,
  class: "success-modal"
};
const _hoisted_26 = {
  class: "modal-inner"
};
import { ref, reactive, onMounted, onUnmounted } from 'vue';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';

// 导入本地图片
import fuwuhaoImg from '../assets/imgs/fuwuhao.jpg';
import qqQunImg from '../assets/imgs/qqqun.jpg';

/* ========== 折叠逻辑 ========== */

export default {
  __name: 'Contact',
  setup(__props) {
    /* eslint-disable */
    const openIndex = ref(null);
    const toggle = i => {
      openIndex.value = openIndex.value === i ? null : i;
    };

    /* ========== 渠道数据 ========== */
    const channels = reactive([{
      type: 'wechat-official',
      icon: 'icon-wechat',
      title: '微信服务号',
      desc: '获取最新产品动态和睡眠指南',
      actionText: '扫码关注',
      payload: 'SleepAI_Official',
      displayInfo: 'ST051085382052',
      showQr: false,
      alwaysShow: false,
      qrCode: fuwuhaoImg,
      qrTip: '关注服务号'
    }, {
      type: 'tel',
      icon: 'icon-phone',
      title: '免费电话',
      desc: '工作日 9-21 点，周末 10-18 点',
      actionText: '立即拨打',
      payload: '0510-85382052',
      displayInfo: '0510-85382052',
      showInfo: false
    }, {
      type: 'email',
      icon: 'icon-email',
      title: '邮件支持',
      desc: '复杂技术问题附日志，24h 内必回',
      actionText: '复制邮箱',
      payload: '2759450915@qq.com',
      displayInfo: '2759450915@qq.com',
      showInfo: false
    }, {
      type: 'qq',
      icon: 'icon-qq',
      title: 'QQ 群',
      desc: '用户交流群，工程师在线答疑',
      actionText: '加群',
      payload: '1042265176',
      displayInfo: '1042265176',
      showQr: false,
      alwaysShow: false,
      qrCode: qqQunImg,
      qrTip: '加入QQ群'
    }]);

    // 切换二维码常驻显示
    const toggleAlwaysShow = channel => {
      channels.forEach(c => {
        if (c.type !== channel.type && (c.type === 'wechat-official' || c.type === 'qq')) {
          c.alwaysShow = false;
          c.showQr = false;
        }
      });
      channel.alwaysShow = !channel.alwaysShow;
      channel.showQr = channel.alwaysShow;
    };

    // 关闭所有二维码
    const closeAllQrCodes = () => {
      channels.forEach(c => {
        if (c.type === 'wechat-official' || c.type === 'qq') {
          c.alwaysShow = false;
        }
      });
    };

    // 点击外部关闭二维码
    const handleClickOutside = event => {
      const isClickInsideQrPopup = event.target.closest('.qr-popup');
      const isClickInsideActionBtn = event.target.closest('.action-btn');
      if (!isClickInsideQrPopup && !isClickInsideActionBtn) {
        closeAllQrCodes();
      }
    };
    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });
    const handleCopy = async c => {
      try {
        await navigator.clipboard.writeText(c.payload);
        alert('已复制到剪贴板: ' + c.payload);
      } catch (err) {
        console.error('复制失败:', err);
        const textArea = document.createElement('textarea');
        textArea.value = c.payload;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        alert('已复制到剪贴板: ' + c.payload);
      }
    };

    /* ========== FAQ 数据 ========== */
    const faqs = [{
      title: '头戴设备会不会有辐射？',
      answer: 'NeuroSky 芯片仅被动读取脑电，不发射任何信号，已通过 FCC/CE 认证。'
    }, {
      title: '枕头喇叭会扰民吗？',
      answer: '喇叭最大功率 1 W，贴耳声压 45 dB，枕边人也小于 25 dB，低于空调风声。'
    }, {
      title: '7 天无理由退货真的免费？',
      answer: '是的，顺丰上门取件，我们承担双向运费，无需任何理由。'
    }, {
      title: '头戴设备无法连接蓝牙怎么办？',
      answer: '请尝试以下步骤排查：1. 重启头戴设备和手机蓝牙；2. 检查设备电量是否充足；3. 确认设备在手机蓝牙可发现列表中；4. 尝试忘记设备后重新配对。如果以上方法无效，请联系技术支持。'
    }, {
      title: '枕头喇叭没声音？',
      answer: '请检查：1. 确认蓝牙接收器与手机已成功连接；2. 检查手机和枕头音量设置；3. 尝试播放其他音频测试喇叭是否正常；4. 重启蓝牙接收器。'
    }, {
      title: '音频推送失败怎么解决？',
      answer: '音频推送失败可能原因：1. 网络连接不稳定 - 请检查WiFi或移动数据；2. APP版本过旧 - 请更新到最新版本；3. 设备存储空间不足 - 请清理缓存；4. 服务器暂时繁忙 - 请稍后重试。如问题持续，请联系技术支持。'
    }, {
      title: '设备保修期限是多久？',
      answer: '我们的保修政策：头戴设备、智能枕头及喇叭1年保修，配件（充电线等）6个月保修。保修期内非人为损坏免费维修。'
    }, {
      title: '有哪些合作模式？',
      answer: '我们提供多种合作模式：1. 线下渠道代理；2. 医疗机构合作（睡眠监测辅助方案，已对接睡眠中心）；3. 企业礼品定制（职场人群助眠套装，支持LOGO定制）。'
    }];

    /* ========== 表单 ========== */
    const form = reactive({
      cooperationType: '',
      companyName: '',
      contactPerson: '',
      phone: '',
      requirements: ''
    });
    const showSuccessModal = ref(false);

    // 修改后的表单提交方法，对接你的后端接口
    const submitForm = async () => {
      try {
        // 前端基础验证
        if (!form.cooperationType) {
          alert('请选择合作类型！');
          return;
        }
        if (!form.companyName) {
          alert('请输入公司名称！');
          return;
        }
        if (!form.contactPerson) {
          alert('请输入联系人姓名！');
          return;
        }
        if (!form.phone) {
          alert('请输入联系电话！');
          return;
        }
        if (!form.requirements) {
          alert('请描述合作需求！');
          return;
        }

        // 调用后端接口
        const response = await fetch('https://www.stst-ibs.com/esleepApi/api/cooperation_submit.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json' // 后端支持JSON格式
          },
          body: JSON.stringify(form) // 将表单数据转为JSON
        });

        // 解析后端响应
        const result = await response.json();

        // 根据后端返回结果处理
        if (result.result === 'OK') {
          showSuccessModal.value = true;
          // 重置表单
          Object.assign(form, {
            cooperationType: '',
            companyName: '',
            contactPerson: '',
            phone: '',
            requirements: ''
          });
        } else {
          // 显示后端返回的错误信息
          alert(result.errorInfo || '提交失败，请稍后重试');
        }
      } catch (error) {
        // 捕获网络错误或接口异常
        console.error('提交异常：', error);
        alert('网络异常或接口错误，请检查后重试！');
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(NavBar), _createElementVNode("div", {
        class: "contact-wrap",
        onClick: closeAllQrCodes
      }, [_cache[21] || (_cache[21] = _createElementVNode("section", {
        class: "hero"
      }, [_createElementVNode("h1", null, "有任何睡眠困扰？3 分钟内必有回应"), _createElementVNode("p", null, "专业睡眠顾问 + 脑机接口工程师 7×14 小时在线")], -1)), _createElementVNode("section", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channels, c => {
        return _openBlock(), _createElementBlock("div", {
          class: "channel",
          key: c.type,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("i", {
          class: _normalizeClass([['iconfont', c.icon], "icon"])
        }, null, 2), _createElementVNode("h3", null, _toDisplayString(c.title), 1), _createElementVNode("p", _hoisted_2, _toDisplayString(c.desc), 1), ['wechat-official', 'qq'].includes(c.type) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
          class: "qr-hover-area",
          onMouseenter: $event => c.showQr = true,
          onMouseleave: $event => c.showQr = false
        }, [_createElementVNode("button", {
          class: "action-btn",
          onClick: $event => toggleAlwaysShow(c)
        }, _toDisplayString(c.alwaysShow ? '收起二维码' : c.actionText), 9, _hoisted_5), c.showQr || c.alwaysShow ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "qr-popup",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("img", {
          src: c.qrCode,
          alt: c.title,
          class: "qr-image"
        }, null, 8, _hoisted_6), _createElementVNode("p", _hoisted_7, "扫码" + _toDisplayString(c.qrTip), 1), _createElementVNode("p", _hoisted_8, [_createElementVNode("i", {
          class: _normalizeClass(['iconfont', c.type === 'wechat-official' ? 'icon-user' : 'icon-qq'])
        }, null, 2), _createTextVNode(" 账号: " + _toDisplayString(c.displayInfo), 1)])])) : _createCommentVNode("", true)], 40, _hoisted_4)])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
          class: "copy-hover-area",
          onMouseenter: $event => c.showInfo = true,
          onMouseleave: $event => c.showInfo = false
        }, [_createElementVNode("button", {
          class: "action-btn",
          onClick: $event => handleCopy(c)
        }, _toDisplayString(c.actionText), 9, _hoisted_11), c.showInfo ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(c.displayInfo), 1), _cache[8] || (_cache[8] = _createElementVNode("p", {
          class: "copy-tip"
        }, "点击复制", -1))])) : _createCommentVNode("", true)], 40, _hoisted_10)]))]);
      }), 128))]), _createElementVNode("section", _hoisted_14, [_cache[9] || (_cache[9] = _createElementVNode("h2", null, "还没开口，先看这里", -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(faqs, (q, i) => {
        return _createElementVNode("div", {
          class: "faq-item",
          key: i
        }, [_createElementVNode("div", {
          class: "faq-title",
          onClick: $event => toggle(i)
        }, [_createElementVNode("span", null, _toDisplayString(q.title), 1), _createElementVNode("i", {
          class: _normalizeClass(["iconfont icon-arrow-down", {
            open: openIndex.value === i
          }])
        }, null, 2)], 8, _hoisted_15), _createVNode(_Transition, {
          name: "slide"
        }, {
          default: _withCtx(() => [openIndex.value === i ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(q.answer), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]);
      }), 64))]), _createElementVNode("section", _hoisted_17, [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "section-header"
      }, [_createElementVNode("i", {
        class: "iconfont icon-file-contract"
      }), _createElementVNode("h2", null, "合作咨询")], -1)), _createElementVNode("form", {
        class: "cooperation-form",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[11] || (_cache[11] = _createElementVNode("label", null, "合作类型", -1)), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.cooperationType = $event),
        required: ""
      }, _cache[10] || (_cache[10] = [_createStaticVNode("<option value=\"\" data-v-f74e0c72>请选择合作类型</option><option value=\"distribution\" data-v-f74e0c72>渠道分销</option><option value=\"oem\" data-v-f74e0c72>OEM/ODM</option><option value=\"technology\" data-v-f74e0c72>技术合作</option><option value=\"investment\" data-v-f74e0c72>投资合作</option>", 5)]), 512), [[_vModelSelect, form.cooperationType]])]), _createElementVNode("div", _hoisted_20, [_cache[12] || (_cache[12] = _createElementVNode("label", null, "公司名称", -1)), _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.companyName = $event),
        placeholder: "请输入公司名称",
        required: ""
      }, null, 512), [[_vModelText, form.companyName]])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_cache[13] || (_cache[13] = _createElementVNode("label", null, "联系人", -1)), _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.contactPerson = $event),
        placeholder: "请输入联系人姓名",
        required: ""
      }, null, 512), [[_vModelText, form.contactPerson]])]), _createElementVNode("div", _hoisted_23, [_cache[14] || (_cache[14] = _createElementVNode("label", null, "联系电话", -1)), _withDirectives(_createElementVNode("input", {
        type: "tel",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.phone = $event),
        placeholder: "请输入联系电话",
        required: ""
      }, null, 512), [[_vModelText, form.phone]])])]), _createElementVNode("div", _hoisted_24, [_cache[15] || (_cache[15] = _createElementVNode("label", null, "合作需求描述", -1)), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.requirements = $event),
        placeholder: "请详细描述您的合作需求...",
        required: ""
      }, null, 512), [[_vModelText, form.requirements]])]), _cache[16] || (_cache[16] = _createElementVNode("button", {
        type: "submit",
        class: "submit-btn"
      }, "提交合作意向", -1))], 32)]), showSuccessModal.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "moon-animation"
      }, [_createElementVNode("i", {
        class: "iconfont icon-moon"
      })], -1)), _cache[19] || (_cache[19] = _createElementVNode("h3", null, "留言已收到", -1)), _cache[20] || (_cache[20] = _createElementVNode("p", null, [_createTextVNode("我们会在睡前1小时前回复，"), _createElementVNode("br"), _createTextVNode("不打扰您的休息~")], -1)), _createElementVNode("button", {
        class: "close-btn",
        onClick: _cache[7] || (_cache[7] = $event => showSuccessModal.value = false)
      }, "知道了")])])) : _createCommentVNode("", true)]), _createVNode(Footer)], 64);
    };
  }
};